import * as types from './constants.js';
import { DeleteRequest } from '../../../Api';
import * as NotificationActions from '../Notification/actions';

const messageFor = (mode, hasPaidVotes) => {
    if (mode === 'soft') {
        return hasPaidVotes
            ? 'Nominee archived (had paid votes — kept for audit).'
            : 'Nominee archived (had votes — kept for audit).';
    }
    return 'Nominee deleted.';
};

/**
 * Delete a nominee. The backend decides whether to soft- or hard-delete based
 * on the nominee's vote history; the payload here just reports which happened.
 *
 * @param {number|string} id
 * @param {string} token
 * @param {{ onSuccess?: (result: { mode: string, has_paid_votes: boolean, deleted: boolean, id: number }) => void, onError?: (err: unknown) => void }} [callbacks]
 */
export const DeleteNominee = (id, token, callbacks = {}) => {
    return (dispatch) => {
        dispatch(Loading(true));

        return DeleteRequest(`nominee/${id}`, token)
            .then((response) => {
                const payload = response && response.data ? response.data : {};

                if (!payload.deleted) {
                    dispatch(Loading(false));
                    dispatch(
                        NotificationActions.SetMessage(
                            (response && response.message) || 'Failed to delete nominee.'
                        )
                    );
                    callbacks.onError && callbacks.onError(response);
                    return;
                }

                const result = { ...payload, id };

                dispatch({
                    type: types.DELETE_NOMINEE,
                    payload: result
                });

                // DELETE_NOMINEE already resets isLoading in the reducer, but
                // we don't rely on that contract here — reset explicitly.
                dispatch(Loading(false));

                dispatch(
                    NotificationActions.SetMessage(
                        messageFor(payload.mode, !!payload.has_paid_votes)
                    )
                );

                callbacks.onSuccess && callbacks.onSuccess(result);
            })
            .catch((error) => {
                console.log(error);
                dispatch(Loading(false));
                dispatch(NotificationActions.SetMessage('Failed to delete nominee.'));
                callbacks.onError && callbacks.onError(error);
            });
    };
};

export const Loading = (isLoading) => {
    return (dispatch) => {
        dispatch({
            type: types.LOADING_STATUS,
            payload: isLoading
        });
    };
};
